var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SrSelect',{attrs:{"value":_vm.modelValue,"disabled":_vm.disabled,"items":_vm.vastEventTypes,"required":_vm.required,"label":"Type","no-data-text":"No video event types available"},on:{"change":_vm.onSelectChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }